import { Button, CircularProgress, TextField } from '@mui/material';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../contexts/configContext';
import Backend from '../services/wordpressBackend';

function Admin() {
	const config = useContext(ConfigContext);
	const [settings, setSettings] = useState(null);

	const getSettings = useCallback(async configData => {
		setSettings(await Backend.getSettings(configData));
	}, []);

	useEffect(() => {
		if (!settings && config) {
			getSettings(config);
		}
	}, [settings, config, getSettings]);

	const handleChange = evt => {
		setSettings(prev => ({ ...prev, [evt.target.name]: evt.target.value }));
	};

	const handleSave = async () => {
		try {
			await Backend.saveSettings(config, settings);
		} catch (error) {
			console.log('error');
		}
	};

	return (
		<div>
			{settings ? (
				<>
					<div className='text-4xl p-4 font-bold'>Hammurabi Tools Configuration</div>
					<div className='m-4'>
						<TextField
							name='apply_now_url'
							label='Apply now URL'
							value={settings?.apply_now_url || ''}
							onChange={handleChange}
							variant='outlined'
							fullWidth
						/>
					</div>
					<div className='m-4'>
						<TextField
							name='schedule_a_call_url'
							label='Schedule a Call URL'
							value={settings?.schedule_a_call_url || ''}
							onChange={handleChange}
							variant='outlined'
							fullWidth
						/>
					</div>
					<div className='m-4'>
						<TextField
							name='dont_apply_url'
							label='Does not apply URL'
							value={settings?.dont_apply_url || ''}
							onChange={handleChange}
							variant='outlined'
							fullWidth
						/>
					</div>
					<div className='m-4'>
						<TextField
							name='auth0_id'
							label='Auth0 Client ID'
							value={settings?.auth0_id || ''}
							onChange={handleChange}
							variant='outlined'
							fullWidth
						/>
					</div>
					<div className='m-4'>
						<TextField
							name='auth0_callback'
							label='Auth0 CallBack'
							value={settings?.auth0_callback || ''}
							onChange={handleChange}
							variant='outlined'
							fullWidth
						/>
					</div>
					<div className='m-4'>
						<TextField
							name='auth0_domain'
							label='Auth0 Domain'
							value={settings?.auth0_domain || ''}
							onChange={handleChange}
							variant='outlined'
							fullWidth
						/>
					</div>
					<div className='m-4'>
						<TextField
							name='full_calculator_url'
							label='Full Calculator URL'
							value={settings?.full_calculator_url || ''}
							onChange={handleChange}
							variant='outlined'
							fullWidth
						/>
					</div>
					<div className='p-4'>
						<Button onClick={handleSave} variant='contained'>
							SAVE CONFIGURATION
						</Button>
					</div>
				</>
			) : (
				<div className='p-8'>
					{' '}
					<CircularProgress />{' '}
				</div>
			)}
		</div>
	);
}

export default Admin;
